// libraries
import React from "react";

// components
import Content from "../components/Register/Content/Content";

const Register = () => {
  return <Content />;
};

export default Register;
